import wx from 'weixin-js-sdk'
import { Toast } from 'mint-ui'

const sdkService = {
    wxShare(data,option) {
        wx.config({
            debug: false, // 开启调试模式
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: [
                'checkJsApi',
                'updateTimelineShareData',
                'updateAppMessageShareData',
                'onMenuShareQQ',
                'onMenuShareWeibo',
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(function(){
            wx.updateTimelineShareData({
                title: option.title, // 分享标题
                link: option.link, // 分享链接
                imgUrl: option.imgUrl, // 分享图标
                desc: option.desc, // 分享描述
                success() {
                    // 用户成功分享后执行的回调函数
                    option.success()
                    // Toast({
                    //     message: 'wx.ready',
                    //     position: 'bottom',
                    //     duration: 5000
                    //   });
                },
                cancel() {
                    // 用户取消分享后执行的回调函数
                    option.error()
                }
            });
            wx.updateAppMessageShareData({
                title: option.title, // 分享标题
                desc:  option.desc, // 分享描述
                link:  option.link, // 分享链接
                imgUrl:  option.imgUrl, // 分享图标
                success() {
                    // 用户成功分享后执行的回调函数
                    option.success()
                    // Toast({
                    //     message: 'wx.updateAppMessageShareData',
                    //     position: 'top',
                    //     duration: 5000
                    //   });
                },
                cancel() {
                    // 用户取消分享后执行的回调函数
                    option.error()
                }
            })
            wx.onMenuShareQQ({
                title: option.title, // 分享标题
                desc:  option.desc, // 分享描述
                link:  option.link, // 分享链接
                imgUrl:  option.imgUrl, // 分享图标
                success() {
                    // 用户成功分享后执行的回调函数
                    option.success()
                },
                cancel() {
                    // 用户取消分享后执行的回调函数
                    option.error()
                }
            })
            wx.onMenuShareWeibo({
                title: option.title, // 分享标题
                desc:  option.desc, // 分享描述
                link:  option.link, // 分享链接
                imgUrl:  option.imgUrl, // 分享图标
                success() {
                    // 用户成功分享后执行的回调函数
                    option.success()
                },
                cancel() {
                    // 用户取消分享后执行的回调函数
                    option.error()
                }
            })
        })
    },
    wxHideShare(data,option) {
        wx.config({
            debug: false, // 开启调试模式
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: [
                'checkJsApi',
                'hideMenuItems',
                'showMenuItems'
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(function(){
            wx.hideMenuItems({
                menuList: ['menuItem:share:appMessage','menuItem:share:timeline','menuItem:share:qq','menuItem:share:weiboApp','menuItem:share:QZone'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
            });
        })
    }
}
export default sdkService